import app from "flarum/forum/app";
import { extend, override } from "flarum/common/extend";
import DiscussionListItem from "flarum/forum/components/DiscussionListItem";
import MinimalDiscussionListItem from "flarum/forum/components/MinimalDiscussionListItem";
import Link from "flarum/common/components/Link";
import Tooltip from "flarum/common/components/Tooltip";
import listItems from "flarum/common/helpers/listItems";
import highlight from "flarum/common/helpers/highlight";
export default function styleDiscussionList() {
  extend(DiscussionListItem.prototype, "elementAttrs", function (attrs) {
    if (!(this instanceof MinimalDiscussionListItem)) {
      attrs.className += " XgayDiscussionListItem";
    }
  });
  extend(DiscussionListItem.prototype, "contentItems", function (items) {
    if (this instanceof MinimalDiscussionListItem) return;
    const discussion = this.attrs.discussion;
    const href = app.route.discussion(discussion, this.getJumpTo());
    const info = this.infoItems();
    if (info.has("excerpt")) info.remove("excerpt");
    if (info.has("tags")) info.setPriority("tags", -200);
    items.remove("main").remove("stats");
    items.add("xgay-title", m(Link, {
      href: href,
      className: "XgayDiscussion-titleLink"
    }, m("h2", {
      className: "DiscussionListItem-title"
    }, highlight(discussion.title(), this.highlightRegExp))), 110);
    items.add("xgay-meta", m(Link, {
      href: href,
      className: "XgayDiscussion-meta"
    }, m("ul", {
      className: "DiscussionListItem-info"
    }, listItems(info.toArray()))), 80);
  });
  override(DiscussionListItem.prototype, "badgesView", function (original) {
    if (this instanceof MinimalDiscussionListItem) return original();
    const badges = this.attrs.discussion.badges();
    if (badges.has("sticky")) {
      const label = app.translator.trans("flarum-sticky.forum.badge.sticky_tooltip");
      badges.setContent("sticky", m(Tooltip, {
        text: label
      }, m("span", {
        className: "XgayDiscussion-crown",
        role: "img",
        "aria-label": label,
        tabindex: "0"
      }, "\uD83D\uDC51")));
    }
    return m("ul", {
      className: "DiscussionListItem-badges badges badges--packed"
    }, listItems(badges.toArray()));
  });
}